import {
  Button,
  Card,
  CardContent,
  Menu,
  Modal,
  Switch,
  Typography,
} from "@material-ui/core";
import { useFormik } from "formik";
import {
  CaretDown,
  CaretUp,
  DotsThree,
  PencilLine,
  Trash,
  X,
} from "phosphor-react";
import React, { useContext, useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { fget, fpost } from "../../../../API/callsAPI.js";
import CommentBox from "../../../Utilities/CommentBox/CommentBox.jsx";
import ViewComments from "../../../Utilities/CommentBox/ViewComments/ViewComments.jsx";
import DeleteModal from "../../../Utilities/DeleteModal/DeleteModal.component";
import ErrorOrSuccessMessage from "../../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component.jsx";
import PriorityViewer from "../../../Utilities/PriorityViewer/PriorityViewer.component.jsx";
import StatusViewer from "../../../Utilities/StatusViewer/StatusViewer.jsx";
import TrackableViewer from "../../../Utilities/TrackableViewer/TrackableViewer.jsx";
import UsersViewer from "../../../Utilities/UsersViewer/UsersViewer.jsx";
import TaskToDos from "../../../Utilities/TaskToDos/TaskToDos.jsx";
import { MovieColabContext } from "../../../../Context/MovieColabContext";
import useStyles from "./TaskViewModal.style.js";

export default function TaskViewModal(props) {
  const classes = useStyles();
  const { loggedInUser } = useContext(MovieColabContext);
  const [comments, setComments] = useState([]);
  const [showCircularProgress, setShowCircularProgress] = useState(false);
  const [assignedUser, setAssignedUser] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [optionModalAnchor, setOptionModalAnchor] = useState(null);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [isTaskDetailsExpanded, setIsTaskDetailsExpanded] = useState(true);
  const { getToggleProps, getCollapseProps } = useCollapse({
    isExpanded: isTaskDetailsExpanded,
  });
  const [commentsRefreshCounter, setCommentsRefreshCounter] = useState(0);
  const [repliedTo, setRepliedTo] = useState({});
  const [showReplay, setShowReplay] = useState(null);
  const [reviewers, setReviewers] = useState([]);
  const [switchView, setSwitchView] = useState(false);
  const [checkList, setCheckList] = useState([]);
  const [refreshCheckList, setRefreshCheckList] = useState(0);
  const [currentTab, setCurrentTab] = useState("active");
  const [isDataLoading, setDataLoading] = useState(false);

  const updateCommentsRefreshCounter = () => {
    setCommentsRefreshCounter(commentsRefreshCounter + 1);
  };
  useEffect(() => {
    if (props.task.assigned_users !== null || undefined) {
      // if (typeof props.task.assigned_users == "array") {
      /* if (Array.isArray(props.task.assigned_users)) {
        setAssignedUser([props.task.assigned_users]);
      } else {
      } */
      setAssignedUser(props.task?.assigned_users);
    }
    if (props?.task?.reviewer?.length > 0) {
      let reviewerList = [];
      setReviewers([]);
      props.projectUsers.map((singleUser) => {
        props.task?.reviewer.map((singleReviewer) => {
          if (singleUser.id === singleReviewer) {
            reviewerList.push(singleUser);
          }
        });
      });
      setReviewers(reviewerList);
    } else {
      setReviewers([]);
    }
  }, [props.task]);

  useEffect(() => {
    if (props.task.id) {
      getComments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.task.id, commentsRefreshCounter]);

  const getComments = async () => {
    try {
      const res = await fget({
        url: `trackables/task-comment?task=${props.task.id}`,
      });
      if (res.status === 200 || 201) {
        setComments(res.data.results);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: props.task.name,
      status: props.task.status ? props.task.status.id : "",
      attachment: "",
    },
  });

  const postComment = async (description, attachment) => {
    let formData = new FormData();
    formData.append("name", props.task.name);
    formData.append("description", description);
    formData.append("task", props.task.id);
    formData.append("id", props.projectId);
    if (repliedTo?.id) {
      formData.append("replied_to", repliedTo?.id);
    }
    if (attachment) {
      formData.append("attachment", attachment, attachment.name);
    }
    let data = {
      url: `trackables/task-comment/`,
      data: formData,
    };
    try {
      setShowCircularProgress(true);
      const res = await fpost(data);
      if (res.status === 200 || 201) {
        setShowCircularProgress(false);
        formik.values.comment = "";
        getComments();
        setShowReplay(repliedTo?.id);
        setRepliedTo({});
        setSnackValue({
          isOpen: true,
          message: `Your Comment added Successfully."`,
          isError: false,
        });
      }
    } catch (err) {
      console.log(err);
      setShowCircularProgress(false);
      setSnackValue({
        isOpen: true,
        message: `please fill all the required field`,
        isError: true,
      });
    }
  };

  function destructureTaskComments(description) {
    if (!description) {
      return;
    }
    const descriptionSplit = description.split("<version>");
    //function extracts version viewer name out of a comment description
    if (descriptionSplit.length > 1) {
      //exist version
      // return {
      //   commentText: descriptionSplit[descriptionSplit.length - 1] || "",
      //   versionDetail: descriptionSplit[descriptionSplit.length - 2] || "",
      // };
      return `#${descriptionSplit[descriptionSplit.length - 2]} ${
        descriptionSplit[descriptionSplit.length - 1]
      }`;
    } else {
      // return {
      //   commentText: descriptionSplit[descriptionSplit.length - 1] || "",
      //   versionDetail: null
      // }
      return `${descriptionSplit[descriptionSplit.length - 1]}`;
    }
  }

  const getChecklist = async (loader) => {
    try {
      loader && setDataLoading(true);
      const res = await fget({
        url: `trackables/checklist/?project=${props.projectId}&taskId=${
          props.task.id
        }&completed=${currentTab === "active" ? "False" : "True"}`,
      });
      setCheckList(res.data.results[0]);
      setDataLoading(false);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  };

  const updateRefreshChecklist = () => {
    setRefreshCheckList(refreshCheckList + 1);
  };

  useEffect(() => {
    if (props.task.id) {
      getChecklist("");
    }
  }, [refreshCheckList]);

  useEffect(() => {
    if (props.task.id) {
      getChecklist("loader");
    }
  }, [props.task, currentTab]);

  return (
    <>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <Card className={classes.ViewModalContainer}>
        <CardContent className={classes.cardContent}>
          <div className={classes.taskViewerTools}>
            <div>
              <div className={classes.taskName}>{props.task.name}</div>
              <div className={classes.duration}>
                {new Date(props.task.start_time).toString().substr(4, 6)} -{" "}
                {new Date(props.task.end_time).toString().substr(4, 6)}
              </div>
            </div>
            <div className={classes.buttons}>
              <Button
                onClick={(event) => {
                  setOptionModalAnchor(event.target);
                }}
                style={{ minWidth: "20px" }}
              >
                <DotsThree height={20} width={20} />
              </Button>
              <Button
                style={{ minWidth: "20px" }}
                onClick={() => {
                  props.closeModal();
                  setRepliedTo({});
                }}
              >
                <X className={classes.icon} size={24} />
              </Button>
            </div>
          </div>
          <div {...getCollapseProps({})}>
            <div className={classes.taskDetails}>
              <div>
                {assignedUser?.length > 0 ? (
                  <UsersViewer
                    assignedUser={assignedUser}
                    selectedTask={props?.task}
                    editable="no"
                  />
                ) : (
                  ""
                )}
              </div>
              <div className={classes.statusAndPriority}>
                <div className={classes.labelAndContentGap}>
                  <span className={classes.label}>Status :</span>
                  <div>
                    {props?.task?.status ? (
                      <>
                        <StatusViewer status={props?.task?.status} />
                      </>
                    ) : (
                      "no status"
                    )}
                  </div>
                </div>
                <div className={classes.labelAndContentGap}>
                  <span className={classes.label}>Priority </span>
                  <PriorityViewer priority={props?.task?.priority} />
                </div>
              </div>
              <div className={classes.statusAndPriority}>
                <div className={classes.labelAndContentGap}>
                  <span className={classes.label}>Trackable</span>
                  <div>
                    {props?.task?.id ? (
                      <TrackableViewer
                        trackable={props?.task}
                        viewType={props.viewType}
                      />
                    ) : (
                      "no trackable"
                    )}
                  </div>
                </div>
                <div className={classes.labelAndContentGap}>
                  <span className={classes.label}>Reviewer</span>
                  {reviewers?.length > 0 ? (
                    <UsersViewer
                      assignedUser={reviewers}
                      selectedTask={props?.task}
                      editable="no"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className={classes.descriptionContainer}>
                <div className={classes.label}>Description</div>
                <span style={{ paddingLeft: "10px" }}>
                  {destructureTaskComments(props?.task?.description)}
                </span>
              </div>
            </div>
          </div>
          <div className={classes.dividerLine}>
            <div className={classes.line}></div>
            <div>
              <div
                className={classes.upOrDownIcon}
                {...getToggleProps({
                  onClick: () =>
                    setIsTaskDetailsExpanded(!isTaskDetailsExpanded),
                })}
              >
                {isTaskDetailsExpanded ? (
                  <CaretUp size={20} />
                ) : (
                  <CaretDown size={20} />
                )}
              </div>
            </div>
            <div className={classes.line}></div>
          </div>
          <div
            className={
              isTaskDetailsExpanded
                ? classes.taskToDoContainer
                : classes.taskToDoContainerExpanded
            }
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <Typography>Comment</Typography>
              <Switch
                checked={switchView}
                onChange={(event) => setSwitchView(event.target.checked)}
              />{" "}
              <Typography>Task To Do's</Typography>{" "}
            </div>
            {switchView ? (
              <TaskToDos
                currentTab={currentTab}
                onChangeTab={setCurrentTab}
                linkedTask={props.task}
                toDoType="taskPage"
                updateRefreshChecklist={updateRefreshChecklist}
                checkList={checkList}
                isDataLoading={isDataLoading}
                isTaskDetailsExpanded={isTaskDetailsExpanded}
                projectId={props.projectId}
              />
            ) : (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <div>
                  <CommentBox
                    postComment={postComment}
                    showCircularProgress={showCircularProgress}
                    loggedInUser={loggedInUser}
                    type="newComment"
                    repliedTo={repliedTo}
                    setRepliedTo={setRepliedTo}
                  />
                </div>
                <div
                  style={{
                    height: isTaskDetailsExpanded
                      ? `calc(100% - 350px)`
                      : `calc(100% - 150px)`,
                  }}
                >
                  <ViewComments
                    comments={comments}
                    isTaskDetailsExpanded={isTaskDetailsExpanded}
                    loggedInUser={loggedInUser}
                    updateCommentsRefreshCounter={updateCommentsRefreshCounter}
                    task={props.task}
                    projectId={props.projectId}
                    setSnackValue={setSnackValue}
                    setRepliedTo={setRepliedTo}
                    showReplay={showReplay}
                    setShowReplay={setShowReplay}
                  />
                </div>
              </div>
            )}
          </div>
        </CardContent>
        {/* Menu Popover */}
        <Menu
          anchorEl={optionModalAnchor}
          open={Boolean(optionModalAnchor)}
          onClose={() => setOptionModalAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          MenuListProps={{
            style: {
              padding: "0px",
            },
          }}
        >
          <div className={classes.menuDiv}>
            <Button
              style={{ minWidth: "120px", height: "30px", padding: "4px" }}
              onClick={() => {
                props.switchToEditModal();
              }}
            >
              <div className={classes.editAndCloseButton}>
                <PencilLine size={20} />
                <span>Edit Task</span>
              </div>
            </Button>
            <hr style={{ width: "90%", margin: "1px" }} />
            <Button
              style={{ minWidth: "120px", height: "30px", padding: "4px" }}
              onClick={() => setDeleteModalOpen(true)}
            >
              <div className={classes.editAndCloseButton}>
                <Trash size={20} />
                <span>Delete Task</span>
              </div>
            </Button>
          </div>
        </Menu>
        {deleteModalOpen && (
          <Modal
            open={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DeleteModal
              name={props.task.name}
              type="task"
              handleCloseDeleteModal={() => setDeleteModalOpen(false)}
              handleDelete={() => {
                props.handleTaskDelete(props.task.id).then((res) => {
                  props.closeModal();
                  setOptionModalAnchor(null);
                });
                setDeleteModalOpen(false);
              }}
            />
          </Modal>
        )}
      </Card>
    </>
  );
}
